<template>
    <div class="main">
        <div class="body-content">
            <div class="page-header">
                <h1>Upload POMS</h1>
            </div>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <select id="partyname" v-model="newContainer.partyName" class="custom-select" style="width:100%">
                        <option value="0">Select Party</option>
                        <option v-for="party in party" :key="party.autoid" :value="party.autoid">
                            {{ party.short_name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <select id="vesselName" v-model="newContainer.vesselID" class="custom-select" style="width:100%">
                        <option value="0">Select Vessel</option>
                        <option v-for="vessel in vessel" :key="vessel.Vesselid" :value="vessel.Vesselid">
                            {{ vessel.Name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="movementname">Movement Type *</label>
                    <select id="movementname" v-model="newContainer.movementID" class="custom-select" style="width:100%">
                        <option value="0">Select Movement</option>
                        <option v-for="movement in movementOptions" :key="movement.Movid" :value="movement.Movid">
                            {{ movement.Name }}
                        </option>
                    </select>
                </div>
                <label for="fileAdd">File:</label>
                <input type="file" id="file" @change="handleFileUpload" class="custom-file-input">
            
                <div class="form-item">
                    <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Upload</button>
                    <button type="button" class="excel-button" @click="save" :disabled="isSubmitting">Save</button>
                </div>
            </div>
            <div class="form-item">
                <div v-html="htmlContent"></div>
            </div>
        </div>
        <div class="table-container">
            <table class="transaction-table table-design">
                <thead>
                    <tr>
                        <th>
                            <span>Sl. No</span>
                        </th>
                        <th>
                            <span>Container</span>
                        </th>
                        <th>
                            <span>Tare Wt.</span>
                        </th>
                        <th>
                            <span>Gross Wt</span>
                        </th>
                        <th>
                            <span>POL</span>
                        </th>
                        <th>
                            <span>POD</span>
                        </th>
                        <th>
                            <span>FPD</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ld in fetchedList" :key="ld[0]" class="successful-task">
                        <td>{{ ld[0] }}</td>
                        <th>
                            <span>{{ ld[1] }}</span>
                        </th>
                        <th>
                            <span>{{ ld[2] }}</span>
                        </th>
                        <th>
                            <span>{{ ld[3] }}</span>
                        </th>
                        <th>
                            <span>{{ ld[4] }}</span>
                        </th>
                        <th>
                            <span>{{ ld[5] }}</span>
                        </th>
                        <th>
                            <span>{{ ld[6] }}</span>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>    
    </div>
</template>

<script>
import axios from 'axios';
import 'vue-select/dist/vue-select.css';
import VSelect from 'vue-select';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
    components: {
        VSelect,
    },
    data() {
        return {
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            movementOptions: JSON.parse(localStorage.getItem('activemovements')) || [],
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                VoyId: 0,
                movementID: 0,
                file: null,
            },
            htmlContent: null,
            uploadlist: [],
            sqlqry: null,
            isSubmitting: false,
        }
    },
    computed: {
        fetchedList() {
            //console.log(this.successfulTasks);
            //console.log(this.uploadlist);
            return this.uploadlist;
        },
    },
    methods: {
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async uploadFiles() {
            if (this.isSubmitting) return;
            
            this.isSubmitting = true;
            try {
                const AppAcc = cs.GetAppAccFromParty(this.newContainer.partyName)
                //console.log(AppAcc)
                this.newContainer.applicantID = AppAcc.applicantid
                this.newContainer.accountID = AppAcc.accountid
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        'Content-Type': 'multipart/form-data'
                    },
                };
                const data = new FormData();
                data.append('file', this.newContainer.file);
                const response = await axios.post('/upload_pomsupdate?applicantid=' + this.newContainer.applicantID + '&accountid=' + this.newContainer.accountID + '&vesselid=' + this.newContainer.vesselID + '&voyageid=' + this.newContainer.VoyId + '&movementid=' + this.newContainer.movementID, data, config);
                //console.log(response.data)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.uploadlist = response.data[2]
                    this.sqlqry = response.data[3]
                    //this.resetNewContainer();
                }
            } catch (error) {
                console.error('Error uploading files:', error);
                useToast().error('An error occurred while uploading files');
            } finally {
                this.isSubmitting = false;
            }
        },
        async save() {
            if (this.isSubmitting) return;
            
            this.isSubmitting = true;
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                };
                const qrydata = {
                    qry: this.sqlqry
                }
                const data = new FormData();
                const transdt = JSON.stringify(qrydata)
                //console.log(this.sqlqry)
                //console.log(transdt)
                data.append('transaction', transdt)

                const response = await axios.post('/execute_pomsupdate', data, config);
                //console.log(response.data)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.uploadlist = null
                    this.sqlqry = null
                    //this.resetNewContainer();
                }
            } catch (error) {
                console.error('Error saving data:', error);
                useToast().error('An error occurred while saving data');
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}

</script>
<style scoped>
/* Form group styling for form elements */
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>